const getDefaultState = () => {
    return {
        fonds1: {
            chartUrl:
                "https://lt.morningstar.com/uut02b8539/snapshot/snapshot.aspx?id=F00000VIEK&SecurityToken=F00000VIEK%5d2%5d1%5dFOALL%24%24ALL_3678&ClientFund=1&LanguageId=de-DE&CurrencyId=EUR&UniverseId=FOALL%24%24ALL_3678&BaseCurrencyId=EUR",
        },
        fonds2: {
            chartUrl:
                "https://lt.morningstar.com/uut02b8539/snapshot/snapshot.aspx?id=F00000V4V8&SecurityToken=F00000V4V8%5d2%5d1%5dFOALL%24%24ALL_3678&ClientFund=1&LanguageId=de-DE&CurrencyId=EUR&UniverseId=FOALL%24%24ALL_3678&BaseCurrencyId=EUR",
        },
        fonds7: {
            chartUrl:
                "https://lt.morningstar.com/uut02b8539/snapshot/snapshot.aspx?id=F00000X9H5&SecurityToken=F00000X9H5%5d2%5d1%5dFOALL%24%24ALL_3678&ClientFund=1&LanguageId=de-DE&CurrencyId=EUR&UniverseId=FOALL%24%24ALL_3678&BaseCurrencyId=EUR",
        },
        fonds3: {
            chartUrl:
                "https://lt.morningstar.com/uut02b8539/snapshot/snapshot.aspx?id=F00000MEJL&SecurityToken=F00000MEJL%5d2%5d1%5dFOALL%24%24ALL_3678&ClientFund=1&LanguageId=de-DE&CurrencyId=EUR&UniverseId=FOALL%24%24ALL_3678&BaseCurrencyId=EUR",
        },
        fonds4: {
            chartUrl:
                "https://lt.morningstar.com/uut02b8539/snapshot/snapshot.aspx?id=F0000000EP&SecurityToken=F0000000EP%5d2%5d1%5dFOALL%24%24ALL_3678&ClientFund=1&LanguageId=de-DE&CurrencyId=EUR&UniverseId=FOALL%24%24ALL_3678&BaseCurrencyId=EUR",
        },
        fonds5: {
            chartUrl:
                "https://lt.morningstar.com/uut02b8539/snapshot/snapshot.aspx?id=F00000T4KE&SecurityToken=F00000T4KE%5d2%5d1%5dFOALL%24%24ALL_3678&ClientFund=1&LanguageId=de-DE&CurrencyId=EUR&UniverseId=FOALL%24%24ALL_3678&BaseCurrencyId=EUR",
        },
        fonds6: {
            chartUrl:
                "https://lt.morningstar.com/uut02b8539/snapshot/snapshot.aspx?id=F00000415W&SecurityToken=F00000415W%5d2%5d1%5dFOALL%24%24ALL_3678&ClientFund=1&LanguageId=de-DE&CurrencyId=EUR&UniverseId=FOALL%24%24ALL_3678&BaseCurrencyId=EUR",
        },
        flexiblelife20: {
            fonds1: {
                chartUrl:
                    "https://lt.morningstar.com/uut02b8539/snapshot/snapshot.aspx?id=F00000TE76&SecurityToken=F00000TE76%5d2%5d1%5dFOALL%24%24ALL_3678&ClientFund=1&LanguageId=de-DE&CurrencyId=EUR&UniverseId=FOALL%24%24ALL_3678&BaseCurrencyId=EUR",
            },
            fonds2: {
                chartUrl:
                    "https://lt.morningstar.com/uut02b8539/snapshot/snapshot.aspx?id=0P0000Z9Q2&SecurityToken=0P0000Z9Q2%5d2%5d1%5dFOALL%24%24ALL_3678&ClientFund=1&LanguageId=de-DE&CurrencyId=EUR&UniverseId=FOALL%24%24ALL_3678&BaseCurrencyId=EUR",
            },
            fonds3: {
                chartUrl:
                    "https://lt.morningstar.com/uut02b8539/snapshot/snapshot.aspx?id=F00000MEJL&SecurityToken=F00000MEJL%5d2%5d1%5dFOALL%24%24ALL_3678&ClientFund=1&LanguageId=de-DE&CurrencyId=EUR&UniverseId=FOALL%24%24ALL_3678&BaseCurrencyId=EUR",
            },
            fonds4: {
                chartUrl:
                    "https://lt.morningstar.com/uut02b8539/snapshot/snapshot.aspx?id=F00001060D&SecurityToken=F00001060D%5d2%5d1%5dFOALL%24%24ALL_3678&ClientFund=1&LanguageId=de-DE&CurrencyId=EUR&UniverseId=FOALL%24%24ALL_3678&BaseCurrencyId=EUR",
            },
            fonds5: {
                chartUrl:
                    "https://lt.morningstar.com/uut02b8539/snapshot/snapshot.aspx?id=F00000T4KE&SecurityToken=F00000T4KE%5d2%5d1%5dFOALL%24%24ALL_3678&ClientFund=1&LanguageId=de-DE&CurrencyId=EUR&UniverseId=FOALL%24%24ALL_3678&BaseCurrencyId=EUR",
            },
            fonds6: {
                chartUrl:
                    "https://lt.morningstar.com/uut02b8539/snapshot/snapshot.aspx?id=F00000415W&SecurityToken=F00000415W%5d2%5d1%5dFOALL%24%24ALL_3678&ClientFund=1&LanguageId=de-DE&CurrencyId=EUR&UniverseId=FOALL%24%24ALL_3678&BaseCurrencyId=EUR",
            },
        },
    };
};

const state = getDefaultState();

export default {
    state,
};
